module.exports = __webpack_public_path__ + "static/media/leasetic vert.d1542c57.png";